/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate } from "react-router-dom";
import { Box } from "./widgets";
import { IN, formatShort, formatLabel, fx, crestColor, initials } from "./model";
import { buildLeagues } from "./leaguesModel";

const LeaguesSection = ({ overview, teams }: { overview: any; teams: any[] }) => {
  const nav = useNavigate();
  const leagues = buildLeagues(overview, teams);
  if (!leagues.length) return null;
  const tournaments = leagues.reduce((a, l) => a + l.rows.length, 0);
  return (
    <Box title="Leagues and tournaments" sub={`${leagues.length} league${leagues.length === 1 ? "" : "s"} · ${tournaments} tournament${tournaments === 1 ? "" : "s"}`}>
      <div className="lgs">
        {leagues.map((l) => (
          <section className="lg" key={l.id}>
            <header className="lg-h">
              <span className="crest" style={{ background: crestColor(l.name) }}>{initials(l.name)}</span>
              <div className="lg-t"><h4>{l.name}</h4><span>{l.rows.length} tournament{l.rows.length === 1 ? "" : "s"} · {l.m} matches</span></div>
              <div className="lg-tot"><b>{IN(l.r)}</b><span>runs</span></div>
              <div className="lg-tot"><b>{l.w}</b><span>wickets</span></div>
            </header>
            <div className="lg-rows">
              {l.rows.map((t) => (
                <button key={t.id} type="button" className="lg-row" onClick={() => t.id && nav(`/tournamentDetails/${t.id}`)}>
                  <div className="lg-name"><b>{t.name}</b><span>{[t.year, t.team].filter(Boolean).join(" · ")}</span></div>
                  {t.format && <span className="fmt" title={formatLabel(t.format)}>{formatShort(t.format)}</span>}
                  <div className="lg-s"><b>{t.m}</b><span>M</span></div>
                  <div className="lg-s"><b>{IN(t.r)}</b><span>Runs</span></div>
                  <div className="lg-s"><b>{t.hs}</b><span>HS</span></div>
                  <div className="lg-s"><b>{fx(t.avg)}</b><span>Avg</span></div>
                  <div className="lg-s"><b>{t.w}</b><span>Wkts</span></div>
                </button>
              ))}
            </div>
          </section>
        ))}
      </div>
    </Box>
  );
};
export default LeaguesSection;
